import { useContext } from 'react';

import { AuthContext } from 'Jsx/ContextApis/AuthContext';

const useMe = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useMe must be used within an AuthProvider');
  }

  return context.data;
};

export default useMe;
